import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Popover } from 'antd';
import { DashboardStore } from '@/stores';
import EntranceSetting from '@/pages/dashboard/component/entranceSetting';
import type { EntranceItem } from '@/pages/dashboard/component/entranceSetting';
import { Icon } from '@/components';
import { ApplicationInfo } from '@/const/application';
import './index.less';

export default observer(() => {
  const { systemId } = ApplicationInfo;
  const [open, setOpen] = useState<boolean>(false);
  const [entryList, setEntryList] = useState<EntranceItem[]>([]);

  const getEntryList = async () => {
    const res = await DashboardStore.getUsageQuickMenuList({
      systemId,
    });
    setEntryList(res.data || []);
  };

  const handleTapClick = (item: EntranceItem) => {
    const { path, redirect, target } = item;
    const url = redirect || path;

    window.open(url, target);
  };

  useEffect(() => {
    getEntryList();
  }, []);

  return (
    <>
      <div className="entrance-list">
          {entryList?.map((item) => (
            <div
              className="entrance-item"
              key={item.id}
              onClick={() => handleTapClick(item)}
            >
              <Popover placement="bottom" content={item.name}>
                <img className="item-img" src={item.quickIcon} />
                <div className="item-name">
                    {item.name}
                </div>
              </Popover>
            </div>
          ))}
          <div className="entrance-add" onClick={() => setOpen(true)}>
            <Icon type="icon-tianjia" style={{ fontSize: 24}} />
          </div>
      </div>
      <EntranceSetting
        open={open}
        onClose={() => setOpen(false)}
        onLoad={getEntryList}
        usageEntryList={entryList}
      />
    </>
  );
});
